module.exports = __webpack_public_path__ + "assets/0af46117eaf8eb15153dc8d705264416.png";